"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../mixins/siteText"));
const ElementIds_1 = require("../enums/ElementIds");
const userTelemetry_1 = require("../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'disclosure',
    props: {
        content: {
            type: String,
            required: true,
        },
        checkboxLabel: {
            type: String,
            required: true,
        },
        printLinkText: {
            type: String,
            required: true,
        },
    },
    computed: {
        elementIds: () => ElementIds_1.ElementIds,
        isMobile() {
            return this.$store.getters.isMobile;
        },
        disclosurePrintLink() {
            return `/Content/Disclosures/Print?name=${this.$store.state.currentChallenge.DisclosureName}`;
        },
    },
    data: () => {
        return {
            disclosureAccepted: false,
            nearestQuarter: -1,
        };
    },
    mixins: [siteText_1.default],
    methods: {
        toggleAccepted(val) {
            this.disclosureAccepted = val;
            this.$emit('toggleDisclosureAccepted', val);
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.disclosure,
                    action: userTelemetry_1.userAction.agree_clicked,
                    eventProperties: {
                        'value': val,
                    },
                });
            }
        },
        printClicked() {
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.disclosure,
                    action: userTelemetry_1.userAction.print_pdf_clicked,
                });
            }
        },
        scrollDisclosure(event) {
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                const target = event.target;
                const scrollPercent = target.scrollTop / (target.scrollHeight - target.clientHeight);
                // rounded to nearest 25%
                const nearestQuarter = Math.round(Math.round(scrollPercent * 4) / 4 * 100);
                if (nearestQuarter > this.nearestQuarter) {
                    this.nearestQuarter = nearestQuarter;
                    void userTelemetry_1.telemetry.custom({
                        workflowName: workflow,
                        stepType: userTelemetry_1.stepType.progression,
                        stepName: userTelemetry_1.stepName.disclosure,
                        action: userTelemetry_1.userAction.disclosure_scroll,
                        eventProperties: {
                            'position': `${nearestQuarter}%`,
                        },
                    });
                }
            }
        },
    },
});
